// Versão da aplicação (sincronizada com o arquivo VERSION na raiz)
const getMetaVersion = (): string | undefined => {
  if (typeof document === 'undefined') return undefined;
  return document.querySelector('meta[name="app-version"]')?.getAttribute('content') ?? undefined;
};

const FALLBACK_VERSION = '1.2.6';

export const APP_VERSION = import.meta.env.VITE_APP_VERSION ?? getMetaVersion() ?? FALLBACK_VERSION;

